
import { UseFormReturn } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { ProcurementFormValues } from "../../schema";

interface OtherCostDescriptionProps {
  form: UseFormReturn<ProcurementFormValues>;
  otherCost: number;
}

export const OtherCostDescription = ({ form, otherCost }: OtherCostDescriptionProps) => {
  if (parseFloat(String(otherCost)) <= 0) {
    return null;
  }

  return (
    <FormField
      control={form.control}
      name="other_cost_description"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Other Cost Description</FormLabel>
          <FormControl>
            <Textarea
              placeholder="Describe other costs..."
              className="resize-none"
              {...field}
              value={field.value || ''}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
